document.addEventListener('DOMContentLoaded', () => {
  const tabSections = document.querySelectorAll('.pdp_tabs_btn_b7');

  tabSections.forEach(tabBtnContainer => {
    
    const tabAButton = tabBtnContainer.querySelector('.tab_title_a');
    const tabBButton = tabBtnContainer.querySelector('.tab_title_b');

    if (!tabAButton || !tabBButton) {
      console.warn('Tab button not found');
      return;
    }

    if (!tabAButton.classList.contains('active') && !tabBButton.classList.contains('active')) {
      tabAButton.classList.add('active');
    }

    const tabAContents = document.querySelectorAll(`.pdp_tab_A_b7`);
    const tabBContents = document.querySelectorAll(`.pdp_tab_B_b7`);

    // console.log(tabAContents,tabBContents)

    const updateTabs = () => {
      if (tabAButton.classList.contains('active')) {
        tabAContents.forEach(c => c.style.display = '');
        tabBContents.forEach(c => c.style.display = 'none');
      } else if (tabBButton.classList.contains('active')) {
        tabBContents.forEach(c => c.style.display = '');
        tabAContents.forEach(c => c.style.display = 'none');
      } else {
        tabAContents.forEach(c => c.style.display = 'none');
        tabBContents.forEach(c => c.style.display = 'none');
      }
    };

    updateTabs();

    tabAButton.addEventListener('click', () => {
      tabAButton.classList.add('active');
      tabBButton.classList.remove('active');
      updateTabs();
    });

    tabBButton.addEventListener('click', () => {
      tabBButton.classList.add('active');
      tabAButton.classList.remove('active');
      updateTabs();
    });
  });
});
